import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { darken, readableColor, transparentize } from 'polished';

const Wrapper = styled.div`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: column;
    height: 400px;
    width: 100%;
    overflow: hidden;
    margin: 0;
    padding: 0;
`;

const SiteWrapper = styled.div`
    border: solid 1px ${props => props.theme.colors.darkgray};
    height: 400px;
    width: 70%;
    overflow: hidden;
    margin: 0;
    padding: 0;
`;

const HeaderBar = styled.div`
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    background-color: ${props => props.color};
    height: 50px;
    width: 100%;
`;

const SideBar = styled.div`
    background-color: ${props => props.color};
    height: 100%;
    width: 90px;
    display: flex;
    justify-content: flex-start;
    flex-direction: column;
    float: left;
`;

const SideBarLink = styled.div`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    height: 30px;
    color: ${props => readableColor(props.color)};
    
    &.active{
        background-color: ${props => darken(0.1, props.color)};

        i {
            background-color: ${props => props.highlightColor};
        }

        span {
            background-color: ${props => props.highlightColor};
        }
    }

    i {
        height: 10px;
        width: 10px;
        background-color: ${props => transparentize(0.3, readableColor(props.color))};
        border-radius: 50%;
        margin: 0px 10px;
    }

    span {
        width: 40px;
        height: 3px;
        background-color: ${props => transparentize(0.3, readableColor(props.color))};
    }
`;

const BrandLogo = styled.img `
    display: block;
    max-width: 80px;
    max-height: 30px;
    width: auto;
    height: auto;
    margin-left: 10px;
`;

const LogoWrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    width: 90px;
    height: 100%;
    background-color: ${props => props.theme.colors.black};
`;

const MainLogo = styled.div`
    width: 60px;
    height: 17px;
    background-image: url(${props => props.theme.global.images.mainLogo});
    background-size: contain;
    background-repeat: no-repeat;
`;

const TitleBar = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    height: 45px;
    border-bottom: solid 1px ${props => props.theme.colors.darkgray};
`;

const DatePickerWrapper = styled.div`
    width: 200px;
    height: 45px;
    display: flex;
    align-items: center;
    justify-content: flex-end;
    flex-direction: row;
    margin-right: 10px;

    div {
        height: 20px;
        border: solid 1px ${props => props.theme.colors.darkgray};
        margin: 0px 3px;
    }

    .date-range {
        width: 40px;
        
    }

    .date-field {
        width: 25px;
    }

    .date-button {
        display: flex;
        justify-content: center;
        align-items: center;
        width: 25px;
        border: 0px;
        background-color: ${props => props.color};
        box-shadow: 0 1px 2px 0 rgba(0,0,0,0.30);
        color: ${props => readableColor(props.color)};
        font-size: 8px;
    }`;

const EntityDropdownWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-direction: row;
    margin-right: 10px;
    border-right: solid 1px ${props => props.theme.colors.darkgray};

    span {
        width: 120px;
        height: 8px;
        background-color: ${props => props.theme.colors.darkgray};
        margin: 0 5px 0 10px;
    }

    i {
        background-color: ${props => props.color};
        width: 20px;
        height: 20px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-style: normal;
        font-size: 10px;
        transform: rotate(90deg);
        color: ${props => readableColor(props.color)};
    }
`;

const PreviewBranding = (props) => {
    const { headerBarColor, sideBarColor, highlightColor, buttonColor = headerBarColor, logoUrl } = props.data;
    return (
        <Wrapper>
            <SiteWrapper>
                <HeaderBar color={headerBarColor}>
                    <LogoWrapper>
                        <MainLogo />
                    </LogoWrapper>
                    <BrandLogo src={logoUrl} />
                </HeaderBar>
                <SideBar color={sideBarColor} >
                    <SideBarLink highlightColor={highlightColor} color={sideBarColor} >
                        <i /><span />
                    </SideBarLink>
                    <SideBarLink highlightColor={highlightColor} color={sideBarColor} className='active' >
                        <i /><span />
                    </SideBarLink>
                    <SideBarLink highlightColor={highlightColor} color={sideBarColor} >
                        <i /><span />
                    </SideBarLink>
                    <SideBarLink highlightColor={highlightColor} color={sideBarColor} >
                        <i /><span />
                    </SideBarLink>
                </SideBar>
                <TitleBar>
                    <EntityDropdownWrapper color={buttonColor}>
                        <span />
                        <i class='icon-arrow-right'></i>
                    </EntityDropdownWrapper>

                    <DatePickerWrapper color={buttonColor}>
                        <div className='date-range'/>
                        <div className='date-field'/> - <div className='date-field'/>
                        <div className='date-button'>GO</div>
                    </DatePickerWrapper>
                </TitleBar>
            </SiteWrapper>
        </Wrapper>
    );
};

PreviewBranding.propTypes = {
    data: PropTypes.shape({
        brand: PropTypes.string.optional,
        headerBarColor: PropTypes.string.isRequired,
        sideBarColor: PropTypes.string.isRequired,
        highlightColor: PropTypes.string.isRequired,
        logoUrl: PropTypes.string.optional,
    }).isRequired
};

export default PreviewBranding;



// WEBPACK FOOTER //
// ./src/components/molecules/PreviewBranding.js